<template>
  <v-container fluid class="container-view">
    <v-card>
      <v-tabs
        v-model="tab"
        @update:modelValue="tabUpdated"
        align-tabs="start"
        color="#FFB300"
        slider-color="white"
      >
        <v-tab
          v-for="(item, index) in tabItems"
          :key="index"
          elevation="6"
          :value="item.value"
          :class="item.value === tab ? 'v-tab--selected' : ''"
        >
          {{ item.text }}
        </v-tab>

        <v-menu v-if="moreTabItems.length">
          <template v-slot:activator="{ props }">
            <v-btn
              class="align-self-center me-4"
              height="100%"
              rounded="0"
              variant="tonal"
              color="#FFB300"
              v-bind="props"
            >
              Plus
              <v-icon :icon="mdiMenuDown" end></v-icon>
            </v-btn>
          </template>

          <v-list class="bg-grey-lighten-3">
            <v-list-item
              v-for="item in moreTabItems"
              :key="item"
              :title="item.text"
              @click="addItem(item)"
            ></v-list-item>
          </v-list>
        </v-menu>
      </v-tabs>

      <v-tabs-window v-model="tab">
        <v-tabs-window-item
          v-for="(item, index) in [...tabItems, ...moreTabItems]"
          :key="index"
          :value="item.value"
        >
          <component :is="item.component"></component>
        </v-tabs-window-item>
      </v-tabs-window>
    </v-card>

    <v-dialog max-width="500" v-model="dialogValidation" persistent>
      <v-card title="Conditions générales">
        <v-card-text>
          {{ this.termsAndConditions.fullText }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text="Refuser" @click="setDialogValidation('no')"></v-btn>
          <v-btn text="Accepter" @click="setDialogValidation('yes')"></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ClientAdmin from "@/components/ClientAdmin.vue";
import UserAdmin from "@/components/UserAdmin.vue";
import ProductAdmin from "@/components/ProductAdmin.vue";
import StrykerCommandAdmin from "@/components/StrykerCommandAdmin.vue";
import BuyingGroupAdmin from "@/components/BuyingGroupAdmin.vue";
import FranchiseAdmin from "@/components/FranchiseAdmin.vue";
import FranchiseGroupAdmin from "@/components/FranchiseGroupAdmin.vue";
import SubFranchiseAdmin from "@/components/SubFranchiseAdmin.vue";
import TargetProductGroupAdmin from "@/components/TargetProductGroupAdmin.vue";
import GimBrandAdmin from "@/components/GimBrandAdmin.vue";
import GimItemTypeAdmin from "@/components/GimItemTypeAdmin.vue";
import GimProductLineAdmin from "@/components/GimProductLineAdmin.vue";
import GimSubBrandAdmin from "@/components/GimSubBrandAdmin.vue";
import SapgCustomAdmin from "@/components/SapgCustomAdmin.vue";
import GimCustomAdmin from "@/components/GimCustomAdmin.vue";
import SapgAdmin from "@/components/SapgAdmin.vue";
import AddressAdmin from "@/components/AddressAdmin.vue";
import OrderOneStrykerAdmin from "@/components/OrderOneStrykerAdmin.vue";
import TermsAndConditionsAdmin from "@/components/TermsAndConditionsAdmin.vue";
import ContractAdmin from "@/components/ContractAdmin.vue";
import PubAdmin from "@/components/PubAdmin.vue";
import PointAdjustmentView from "@/views/PointAdjustmentView.vue";

import { mdiMenuDown } from "@mdi/js";
import { mapState } from "vuex";

export default {
  name: "AdminView",
  components: {
    ClientAdmin,
    UserAdmin,
    ProductAdmin,
    StrykerCommandAdmin,
    BuyingGroupAdmin,
    FranchiseAdmin,
    FranchiseGroupAdmin,
    SubFranchiseAdmin,
    SapgAdmin,
    TargetProductGroupAdmin,
    GimBrandAdmin,
    GimItemTypeAdmin,
    GimProductLineAdmin,
    GimSubBrandAdmin,
    GimCustomAdmin,
    SapgCustomAdmin,
    AddressAdmin,
    OrderOneStrykerAdmin,
    TermsAndConditionsAdmin,
    ContractAdmin,
    PubAdmin,
    PointAdjustmentView,
  },
  data() {
    return {
      mdiMenuDown,
      tab: null,
      dialogValidation: false,
      tabItems: [
        {
          value: "clients",
          text: this.$t("admin.customers"),
          component: "ClientAdmin",
        },
        {
          value: "users",
          text: this.$t("admin.users"),
          component: "UserAdmin",
        },
        {
          value: "contracts",
          text: this.$t("contracts"),
          component: "ContractAdmin",
        },
        {
          value: "products",
          text: this.$t("products"),
          component: "ProductAdmin",
        },
        {
          value: "pubs",
          text: this.$t("admin.pubs"),
          component: "PubAdmin",
        },
        {
          value: "strykerCommands",
          text: this.$t("stryker-commands"),
          component: "StrykerCommandAdmin",
        },
        {
          value: "ordersOneStryker",
          text: this.$t("orders-stryker-one"),
          component: "OrderOneStrykerAdmin",
        },
        {
          value: "termsAndConditions",
          text: this.$t("admin.terms-and-conditions"),
          component: "TermsAndConditionsAdmin",
        },
        {
          value: "pointAdjustments",
          text: "Ajustements de points",
          component: "PointAdjustmentView",
        },
      ],
      moreTabItems: [
        {
          value: "addresses",
          text: this.$t("addresses"),
          component: "AddressAdmin",
        },
        {
          value: "buyingGroups",
          text: this.$t("buying-group"),
          component: "BuyingGroupAdmin",
        },
        {
          value: "franchises",
          text: this.$t("admin.franchise"),
          component: "FranchiseAdmin",
        },
        {
          value: "franchiseGroups",
          text: this.$t("admin.franchise-group"),
          component: "FranchiseGroupAdmin",
        },
        {
          value: "subFranchises",
          text: this.$t("admin.sub-franchise"),
          component: "SubFranchiseAdmin",
        },
        {
          value: "sapgs",
          text: this.$t("admin.sapg"),
          component: "SapgAdmin",
        },
        {
          value: "targetProductGroups",
          text: this.$t("admin.target-product-group"),
          component: "TargetProductGroupAdmin",
        },
        {
          value: "gimBrands",
          text: this.$t("admin.gim-brand"),
          component: "GimBrandAdmin",
        },
        {
          value: "gimItemTypes",
          text: this.$t("admin.gim-item-type"),
          component: "GimItemTypeAdmin",
        },
        {
          value: "gimProductLines",
          text: this.$t("admin.gim-product-line"),
          component: "GimProductLineAdmin",
        },
        {
          value: "gimSubBrands",
          text: this.$t("admin.gim-sub-brand"),
          component: "GimSubBrandAdmin",
        },
        {
          value: "gimCustoms",
          text: this.$t("admin.gim-custom"),
          component: "GimCustomAdmin",
        },
        {
          value: "sapgCustoms",
          text: this.$t("admin.sapg-custom"),
          component: "SapgCustomAdmin",
        },
      ],
    };
  },
  created() {
    this.$store
      .dispatch(
        "termsAndConditions/userAccepted",
        this.$store.state.users.user.id,
      )
      .then((response) => {
        if (response.data == false) {
          this.$store
            .dispatch("termsAndConditions/getCurrent")
            .then(() => {
              this.dialogValidation = true;
            })
            .catch(() => {
              // Vérification des CGU silencieuse en cas d'erreur
            });
        }
      })
      .catch(() => {
        // Vérification initiale silencieuse en cas d'erreur
      });
  },
  computed: {
    ...mapState({
      termsAndConditionsId: (state) => state.termsAndConditions.editedId,
      termsAndConditions: (state) => state.termsAndConditions.editedItem,
    }),
  },
  methods: {
    addItem(item) {
      // Retirer le dernier élément de tabItems
      const lastTabItem = this.tabItems.pop();

      // Ajouter le dernier élément retiré à moreTabItems
      this.moreTabItems.push(lastTabItem);

      // Ajouter l'élément sélectionné à la fin de tabItems
      this.tabItems.push(item);

      // Retirer l'élément sélectionné de moreTabItems
      this.moreTabItems = this.moreTabItems.filter(
        (moreItem) => moreItem.value !== item.value,
      );

      // Forcer Vuetify à détecter le changement d'onglet
      const previousTab = this.tab; // Sauvegarder l'onglet actif actuel
      this.tab = null; // Réinitialiser temporairement
      this.$nextTick(() => {
        this.tab = previousTab === item.value ? null : item.value; // Définir le nouvel onglet actif
        this.tabUpdated(item.value);
      });
    },
    setDialogValidation(value) {
      if (value == "no") {
        this.logout();
        this.dialogValidation = false;
      } else {
        const data = {
          userId: this.$store.state.users.user.id,
          termVersionId: this.termsAndConditionsId,
          acceptanceDate: new Date().toISOString(),
        };
        this.$store
          .dispatch("termsAndConditions/userConfirmation", data)
          .then(() => {
            this.dialogValidation = false;
          })
          .catch(() => {
            this.dialogValidation = false;
          });
      }
    },
    logout() {
      this.$store.commit("auth/clearAuthData");
      this.$store.dispatch("users/resetSelectedCustomer");
      this.$router.push({ name: "login" });
    },
    tabUpdated(value) {
      this.$store.dispatch("paginations/resetItems");
      this.$store.commit("setOverlay", true);
      if (value == "strykerCommands") {
        this.$store.commit("strykerCommands/setItems", []);
      }
      if (value == "ordersOneStryker") {
        this.$store.commit("ordersOneStryker/setItems", []);
      }

      // pointAdjustments n'a pas besoin de fetchAll, l'historique se charge automatiquement
      if (value == "pointAdjustments") {
        this.$store.commit("setOverlay", false);
        return;
      }

      this.$store.dispatch(`${value}/fetchAll`).then((response) => {
        if (value == "clients") {
          this.$store.dispatch("fetchCustomerAdmin").then(() => {
            this.$store.commit("setOverlay", false);
            this.$store.commit(
              "paginations/setItems",
              JSON.parse(response.headers.get("X-Pagination")),
            );
          });
        } else if (value == "users") {
          this.$store.dispatch("fetchUserAdmin").then(() => {
            this.$store.commit("setOverlay", false);
            this.$store.commit(
              "paginations/setItems",
              JSON.parse(response.headers.get("X-Pagination")),
            );
          });
        } else if (value == "products") {
          this.$store.dispatch("fetchProductAdmin").then(() => {
            this.$store.commit("setOverlay", false);
            this.$store.commit(
              "paginations/setItems",
              JSON.parse(response.headers.get("X-Pagination")),
            );
          });
        } else if (value == "addresses") {
          this.$store
            .dispatch("clients/fetchAll")
            .then(() => {
              this.$store.commit("setOverlay", false);
              this.$store.commit(
                "paginations/setItems",
                JSON.parse(response.headers.get("X-Pagination")),
              );
            })
            .catch(() => {
              this.$store.commit("setOverlay", false);
            });
        } else if (value == "termsAndConditions") {
          this.$store
            .dispatch("termsAndConditions/fetchAll")
            .then(() => {
              this.$store.commit("setOverlay", false);
              this.$store.commit(
                "paginations/setItems",
                JSON.parse(response.headers.get("X-Pagination")),
              );
            })
            .catch(() => {
              this.$store.commit("setOverlay", false);
            });
        } else if (value == "contracts") {
          this.$store.commit("setOverlay", false);
          this.$store.commit(
            "paginations/setItems",
            JSON.parse(response.headers.get("X-Pagination")),
          );
        } else if (value == "pubs") {
          this.$store.commit("setOverlay", false);
        } else {
          this.$store.commit("setOverlay", false);
          this.$store.commit(
            "paginations/setItems",
            JSON.parse(response.headers.get("X-Pagination")),
          );
        }
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("paginations/setSearch", "");
    next();
  },
};
</script>

<style scoped>
.v-btn.v-theme--light.v-btn--density-default.v-btn--size-default.v-btn--variant-text.v-tab:not(
    .v-tab-item--selected
  ):not(.v-tab--selected) {
  background-color: #ffb300;
  color: white;
}
</style>
